import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'dictionary_portfolio'
  static label = 'long'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      long: new STRING(),
      type: new STRING(),
      is_default: new BOOLEAN(),
      uldap_id: new STRING(),
      profile: new ITEM(Profile)
    }
  }
}
